export { api, API } from "./api/_client";
import { api } from "./api/_client";
export * from "./api/admin";
export * from "./api/auth";
export * from "./api/ai";
export * from "./api/contact";
export * from "./api/contacts";
export * from "./api/portfolio";
export * from "./api/email";
export * from "./api/errors";
export * from "./api/estimates";
export * from "./api/leads";
export * from "./api/plugins";
export * from "./api/pricing";
export * from "./api/projects";
export * from "./api/quotes";
export * from "./api/subscriptions";
export * from "./api/templates";
export * from "./api/uploads";
export * from "./api/workgroups";
export * from "./api/hour_log";
export * from "./api/payables";
export * from "./api/files";

export async function downloadTemplateCsv(templateId, templateName = "template") {
    const res = await api.get(`/templates/${templateId}/export-csv`, {
        responseType: "blob",
    });
    const blob = new Blob([res.data], { type: "text/csv" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `${(templateName || "template").replace(/\s+/g, "_")}.csv`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    setTimeout(() => URL.revokeObjectURL(url), 1000);
}

export async function listSelectableTemplates() {
    const { data } = await api.get("/templates/selectable");
    return data;
}

export async function fetchSubscriptionTierImage(storagePath) {
    const { data } = await api.get("/subscription-tiers/image-data", {
        params: { storage_path: storagePath },
    });
    return data;
}
